import { styled } from '@mui/material/styles';
import Saturn from '../assets/images/saturn.svg';
import SaturnLight from '../assets/images/saturn_light.svg';
import Button from '@mui/material/Button';
import { Box, Tab, Tabs } from '@mui/material';

export const BackgroundDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'saturn',
})(({ theme, saturn, isHomePage }) => ({
  backgroundImage:
    saturn != null && saturn
      ? theme.palette.mode === 'dark'
        ? `url(${Saturn})`
        : `url(${SaturnLight})`
      : '',
  backgroundRepeat: 'no-repeat',
  backgroundSize: isHomePage ? '520px' : '',
  '@media (max-width: 600px)': {
    backgroundSize: isHomePage ? '50px' : '',
  },
  '@media (min-width: 601px) and (max-width: 900px)': {
    backgroundSize: isHomePage ? '150px' : '',
  },
  '@media (min-width: 901px) and (max-width: 1200px)': {
    backgroundSize: isHomePage ? '250px' : '',
  },
  '@media (min-width: 1201px) and (max-width: 1536px)': {
    backgroundSize: isHomePage ? '350px' : '',
  },
  '@media (min-width: 1537px)': {
    backgroundSize: isHomePage ? '450px' : '',
  },
  backgroundPosition: 'top right',
  backgroundColor: theme.palette.background.default,
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#fff' : '#bababa',
  color: theme.palette.mode === 'dark' ? '#000' : '#fff',
  borderRadius: '30px',
  width: '136px',
  height: '46px',
  padding: '0 16px',
  '&:hover': {
    backgroundColor: '#eee',
  },
  justifyContent: 'center',
}));

export const AstroDetailsFormStyles = ({ theme }) => ({
  '& .MuiOutlinedInput-root, & .MuiPickersInputBase-root, & .MuiPickersOutlinedInput-notchedOutline':
    {
      width: '324px',
      height: '61px',
      color:
        theme.palette.mode === 'dark'
          ? '#fff !important'
          : '#454545 !important',
      borderRadius: 4,
      borderColor: theme.palette.mode === 'dark' ? '#bababa' : '#000000',
      '& fieldset': {
        borderColor: theme.palette.mode === 'dark' ? '#bababa' : '#000000',
        color: theme.palette.mode === 'dark' ? '#bababa' : '#000000',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.mode === 'dark' ? '#bababa' : '#000000',
        color: theme.palette.mode === 'dark' ? '#bababa' : '#000000',
      },
      '&.MuiInputBase-root': {
        height: '56px !important',
        borderWidth: 2,
      },
      '&.Mui-focused fieldset': {
        borderColor:
          theme.palette.mode === 'dark'
            ? '#bababa !important'
            : '#000000 !important',
        color:
          theme.palette.mode === 'dark'
            ? '#bababa !important'
            : '#000000 !important',
      },
      '& .MuiButtonBase-root &.MuiButton-root &.MuiButton-text &.MuiButton-textPrimary &.MuiButton-sizeMedium &.MuiButton-textSizeMedium &.MuiButton-colorPrimary':
        {
          color:
            theme.palette.mode === 'dark'
              ? '#bababa !important'
              : '#000000 !important',
        },
    },
  '& .MuiInputLabel-root': {
    color:
      theme.palette.mode === 'dark'
        ? '#bababa !important'
        : '#000000 !important',
  },
});

export const StyledTab = styled(Tab)(({ theme }) => ({
  color: '#454545',
  '&.Mui-disabled': {
    color: '#454545B3',
    pointerEvents: 'auto',
  },
  '&.Mui-selected': {
    color:
      theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : '#000000', // selected color
  },
  textTransform: 'none',
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  color: '#454545',
  '& .MuiTabs-indicator': {
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : '#000000', // <-- underline color
  },
}));

export const StyledImageContainerWithMarginBottom = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    marginBottom: '50px',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '80px',
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: '100px',
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: '100px',
    },
  })
);
